import { InjectionToken } from '@angular/core';
import { AuthManagerBase } from '../interface/auth-manager-base';

export const AUTH_MANAGER_BASE_TOKEN = new InjectionToken<AuthManagerBase>('AuthManagerBase');
